const SET_PERMISSIONS = "SET_PERMISSIONS";

const ADD_COUNTRY = "ADD_COUNTRY";
const REMOVE_COUNTRY = "REMOVE_COUNTRY";
const ADD_USER_PERMISSION = "ADD_USER_PERMISSION";
const REMOVE_USER_PERMISSION = "REMOVE_USER_PERMISSION";
const ADD_ADMIN_PERMISSION = "ADD_ADMIN_PERMISSION";
const REMOVE_ADMIN_PERMISSION = "REMOVE_ADMIN_PERMISSION";
const ADD_BASIC_AUTH_PERMISSION = "ADD_BASIC_AUTH_PERMISSION";
const REMOVE_BASIC_AUTH_PERMISSION = "REMOVE_BASIC_AUTH_PERMISSION";
const ADD_BASIC_LOGIN_USER_PERMISSION = "ADD_BASIC_LOGIN_USER_PERMISSION";
const REMOVE_BASIC_LOGIN_USER_PERMISSION = "REMOVE_BASIC_LOGIN_USER_PERMISSION";

export const setPermissions = (payload) => {
    return {
        type: SET_PERMISSIONS,
        payload,
    };
};
export const addCountry = (payload) => {
    return {
        type: ADD_COUNTRY,
        payload,
    };
};
export const removeCountry = (payload) => {
    return {
        type: REMOVE_COUNTRY,
        payload,
    };
};
export const addUserPermission = (payload) => {
    return {
        type: ADD_USER_PERMISSION,
        payload,
    };
};
export const removeUserPermission = (payload) => {
    return {
        type: REMOVE_USER_PERMISSION,
        payload,
    };
};
export const addAdminPermission = (payload) => {
    return {
        type: ADD_ADMIN_PERMISSION,
        payload,
    };
};
export const removeAdminPermission = (payload) => {
    return {
        type: REMOVE_ADMIN_PERMISSION,
        payload,
    };
};
export const addBasicAuthPermission = (payload) => {
    return {
        type: ADD_BASIC_AUTH_PERMISSION,
        payload,
    };
};
export const removeBasicAuthPermission = (payload) => {
    return {
        type: REMOVE_BASIC_AUTH_PERMISSION,
        payload,
    };
};
export const addBasicLoginUserPermission = (payload) => {
    return {
        type: ADD_BASIC_LOGIN_USER_PERMISSION,
        payload,
    };
};
export const removeBasicLoginUserPermission = (payload) => {
    return {
        type: REMOVE_BASIC_LOGIN_USER_PERMISSION,
        payload,
    };
};

const initialState = {
    permissions: {
        countryPermissions: [],
        adminPermissions: [],
        basicAuthPermissions: [],
        basicLoginUserPermissions: [],
        userPermissions: [],
        readPermissions: [],
    },
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_PERMISSIONS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                permissions: {
                    //  ...state.currentUserApps,
                    ...action.payload,
                },
            };

        case REMOVE_COUNTRY:
            if (action.payload === null || action.payload === "") {
                return {
                    ...initialState,
                };
            } else {
                state.permissions.countryPermissions = state.permissions.countryPermissions.filter(
                    (permission) => permission !== action.payload
                );
                return {
                    ...state,
                };
            }

        case ADD_COUNTRY:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            if (!state.permissions.countryPermissions.includes(action.payload)) {
                state.permissions.countryPermissions.push(action.payload);
            }

            return {
                ...state,
            };
        case ADD_USER_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            state.permissions.userPermissions = state.permissions.userPermissions || [];
            if (!state.permissions.userPermissions.includes(action.payload)) {
                state.permissions.userPermissions.push(action.payload);
            }

            return {
                ...state,
            };
        case REMOVE_USER_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            } else {
                state.permissions.userPermissions = state.permissions.userPermissions.filter(
                    (permission) => permission !== action.payload
                );
                return {
                    ...state,
                };
            }
        case ADD_ADMIN_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            state.permissions.adminPermissions = state.permissions.adminPermissions || [];
            if (!state.permissions.adminPermissions.includes(action.payload)) {
                state.permissions.adminPermissions.push(action.payload);
            }

            return {
                ...state,
            };
        case REMOVE_ADMIN_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            } else {
                state.permissions.adminPermissions = state.permissions.adminPermissions.filter(
                    (permission) => permission !== action.payload
                );
                return {
                    ...state,
                };
            }
        case ADD_BASIC_AUTH_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            state.permissions.basicAuthPermissions = state.permissions.basicAuthPermissions || [];
            if (!state.permissions.basicAuthPermissions.includes(action.payload)) {
                state.permissions.basicAuthPermissions.push(action.payload);
            }
            return {
                ...state,
            };
        case REMOVE_BASIC_AUTH_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            } else {
                state.permissions.basicAuthPermissions =
                    state.permissions.basicAuthPermissions.filter(
                        (permission) => permission !== action.payload
                    );
                return {
                    ...state,
                };
            }
        case ADD_BASIC_LOGIN_USER_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            state.permissions.basicLoginUserPermissions =
                state.permissions.basicLoginUserPermissions || [];
            if (!state.permissions.basicLoginUserPermissions.includes(action.payload)) {
                state.permissions.basicLoginUserPermissions.push(action.payload);
            }
            return {
                ...state,
            };
        case REMOVE_BASIC_LOGIN_USER_PERMISSION:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            } else {
                state.permissions.basicLoginUserPermissions =
                    state.permissions.basicLoginUserPermissions.filter(
                        (permission) => permission !== action.payload
                    );
                return {
                    ...state,
                };
            }
        default:
            return state;
    }
};
